import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';
import { handleOcorrenciaChange } from '../../../../../store/reducers/ocorrenciaSlice';

const CampoInputTipoFibra = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { fiber_type } = useSelector(state => state.ocorrenciaState)
    
    const handleChange = (name, value) => {
        dispatch(handleOcorrenciaChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("fiber_type")
    }

    return (
        <CampoInputTexto
            id="inputTipoFibra"
            titulo="Tipo fibra*"
            onChange={handleChange}
            name="fiber_type"
            required
            value={fiber_type}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputTipoFibra
